export interface Article {
  id: string;
  slug: string;
  title: string;
  categorySlug: string;
  summary: string;
  content: string;
  author: string;
  publishDate: string;
  updateDate: string;
  readTime: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'art-001',
    slug: 'http-91-com-latest-access-url',
    title: 'http 91.com 最新官方入口地址（2024年8月更新）',
    categorySlug: 'getting-started',
    summary: '本文汇总 http 91.com 最新官方入口地址，提供多种备用访问方式，确保用户随时能够安全、稳定地访问平台全部功能。',
    content: `<h2>一、http 91.com 官方入口概述</h2>
<p>http 91.com 是国内领先的综合性服务平台，致力于为用户提供高效、便捷的在线服务体验。由于网络环境变化，平台入口地址可能会进行更新，我们建议用户收藏本页面以获取最新的官方入口信息。</p>

<h2>二、最新官方入口地址</h2>
<p>截至2024年8月，<strong>http 91.com</strong> 的官方入口地址为：</p>
<ul>
  <li><strong>主入口：</strong>http 91.com</li>
  <li><strong>备用入口一：</strong>通过官方网站导航页访问</li>
  <li><strong>备用入口二：</strong>使用官方推荐的浏览器书签直达</li>
</ul>

<h2>三、如何确保访问的是官方入口</h2>
<p>为了保障您的账号安全和个人信息不被泄露，请务必通过以下方式确认您访问的是 http 91.com 官方入口：</p>
<ol>
  <li>检查网址是否以 http 91.com 开头</li>
  <li>查看页面底部是否有官方备案信息</li>
  <li>确认浏览器地址栏显示安全连接标识</li>
  <li>通过官方社交媒体渠道获取的最新入口进行访问</li>
</ol>

<h2>四、常见访问问题</h2>
<p>如果遇到无法访问的情况，建议尝试以下解决方案：</p>
<ul>
  <li>清除浏览器缓存和Cookie后重新访问</li>
  <li>更换网络环境（如切换WiFi或使用移动数据）</li>
  <li>尝试使用备用入口地址</li>
  <li>检查本地DNS设置是否正确</li>
</ul>

<h2>五、温馨提示</h2>
<p>请用户注意，http 91.com 不会通过任何非官方渠道要求您提供账号密码。如遇到可疑链接或钓鱼网站，请立即关闭并向官方举报。</p>`,
    author: '91官方编辑',
    publishDate: '2024-08-05',
    updateDate: '2024-08-06',
    readTime: 5,
    tags: ['http 91.com', 'http 91.com 入口', 'http 91.com 最新地址', '91.com 官网'],
  },
  {
    id: 'art-002',
    slug: 'how-to-access-http-91-com',
    title: 'http 91.com 详细访问教程：从零开始的完整指南',
    categorySlug: 'getting-started',
    summary: '本教程面向新用户，手把手教你如何在不同设备和浏览器上安全访问 http 91.com，涵盖PC端和移动端的完整操作步骤。',
    content: `<h2>一、访问前的准备工作</h2>
<p>在开始访问 http 91.com 之前，建议您做好以下准备工作，确保获得最佳的使用体验：</p>
<ul>
  <li>确保您的网络连接稳定</li>
  <li>使用最新版本的Chrome、Edge、Firefox或Safari浏览器</li>
  <li>关闭不必要的浏览器插件</li>
  <li>准备好您的账号信息（如已注册）</li>
</ul>

<h2>二、PC端访问教程</h2>
<p>第一步：打开您的浏览器，在地址栏中输入 http 91.com</p>
<p>第二步：按回车键进入官方网站首页</p>
<p>第三步：在首页顶部导航栏选择您需要的功能模块</p>
<p>第四步：如果是首次访问，建议先浏览"入门指南"栏目了解平台基本功能</p>
<p>第五步：根据需要注册账号或登录已有账号</p>

<h2>三、移动端访问教程</h2>
<p>第一步：打开手机浏览器（推荐使用Chrome或Safari）</p>
<p>第二步：在搜索栏或地址栏输入 http 91.com</p>
<p>第三步：进入移动端适配页面后，可以通过底部导航栏快速切换功能</p>
<p>第四步：建议将网站添加到手机桌面，方便下次快速访问</p>

<h2>四、访问加速小技巧</h2>
<ul>
  <li>将 http 91.com 添加到浏览器书签栏</li>
  <li>使用浏览器的"固定标签页"功能</li>
  <li>定期清理浏览器缓存以保证最佳性能</li>
  <li>使用稳定的网络环境访问</li>
</ul>

<h2>五、安全访问注意事项</h2>
<p>请务必注意以下几点，保障您的访问安全：</p>
<ul>
  <li>不要点击来路不明的"91.com"相关链接</li>
  <li>不要在公共WiFi环境下输入账号密码</li>
  <li>定期修改账号密码</li>
  <li>开启双重认证（如平台支持）</li>
</ul>`,
    author: '91官方编辑',
    publishDate: '2024-07-28',
    updateDate: '2024-08-02',
    readTime: 8,
    tags: ['http 91.com', 'http 91.com 访问教程', '91网站使用指南'],
  },
  {
    id: 'art-003',
    slug: 'http-91-com-platform-features',
    title: 'http 91.com 平台核心功能全面介绍',
    categorySlug: 'features',
    summary: '深入了解 http 91.com 平台提供的各项核心功能，包括内容浏览、互动社区、个性化推荐、数据管理等全方位服务介绍。',
    content: `<h2>一、平台功能总览</h2>
<p>http 91.com 作为一个综合性在线服务平台，提供了丰富多样的功能模块，满足不同用户群体的需求。以下是平台的核心功能详细介绍：</p>

<h2>二、内容浏览功能</h2>
<p>平台拥有海量的优质内容资源，覆盖多个领域：</p>
<ul>
  <li><strong>分类浏览：</strong>支持按类别、标签、热度等多种方式浏览内容</li>
  <li><strong>智能搜索：</strong>强大的搜索引擎帮助用户快速找到所需内容</li>
  <li><strong>个性化推荐：</strong>基于用户浏览历史和行为偏好推荐相关内容</li>
  <li><strong>收藏功能：</strong>支持将喜欢的内容添加到个人收藏夹</li>
</ul>

<h2>三、互动社区功能</h2>
<p>http 91.com 提供完善的社区互动功能：</p>
<ul>
  <li>评论互动：用户可以在内容下方发表评论</li>
  <li>点赞分享：支持对优质内容进行点赞和分享</li>
  <li>关注系统：关注感兴趣的内容创作者</li>
  <li>消息通知：实时接收互动消息和系统通知</li>
</ul>

<h2>四、用户中心功能</h2>
<ul>
  <li><strong>个人资料管理：</strong>编辑头像、昵称、简介等个人信息</li>
  <li><strong>浏览历史：</strong>查看和管理历史浏览记录</li>
  <li><strong>隐私设置：</strong>灵活控制个人信息的可见范围</li>
  <li><strong>账号安全：</strong>密码修改、设备管理、登录记录等安全功能</li>
</ul>

<h2>五、平台特色亮点</h2>
<p>http 91.com 与其他平台相比具有以下独特优势：</p>
<ul>
  <li>界面简洁直观，操作流畅便捷</li>
  <li>内容更新及时，信息真实可靠</li>
  <li>社区氛围友好，互动体验优质</li>
  <li>持续优化迭代，功能不断完善</li>
</ul>`,
    author: '91官方编辑',
    publishDate: '2024-07-20',
    updateDate: '2024-07-25',
    readTime: 6,
    tags: ['91平台功能介绍', 'http 91.com'],
  },
  {
    id: 'art-004',
    slug: 'http-91-com-account-guide',
    title: 'http 91.com 账号注册与登录完整教程',
    categorySlug: 'getting-started',
    summary: '详细介绍 http 91.com 平台账号的注册、登录、密码找回等操作流程，帮助新用户快速完成账号设置并开始使用平台。',
    content: `<h2>一、账号注册流程</h2>
<p>注册 http 91.com 账号非常简单，只需几个步骤即可完成：</p>
<ol>
  <li>访问 http 91.com 官方网站</li>
  <li>点击页面右上角的"注册"按钮</li>
  <li>填写注册信息（用户名、密码、邮箱等）</li>
  <li>阅读并同意用户协议和隐私政策</li>
  <li>点击"注册"提交信息</li>
  <li>验证邮箱或手机号完成注册</li>
</ol>

<h2>二、账号登录方式</h2>
<p>http 91.com 支持多种登录方式：</p>
<ul>
  <li><strong>账号密码登录：</strong>使用注册的用户名/邮箱和密码登录</li>
  <li><strong>手机验证码登录：</strong>通过绑定手机号接收验证码登录</li>
  <li><strong>第三方登录：</strong>支持主流社交平台账号快捷登录</li>
</ul>

<h2>三、密码管理</h2>
<p><strong>修改密码：</strong>登录后在"账号设置-安全中心"中修改密码</p>
<p><strong>找回密码：</strong>如果忘记密码，可以通过以下方式找回：</p>
<ol>
  <li>在登录页面点击"忘记密码"</li>
  <li>输入注册时使用的邮箱或手机号</li>
  <li>接收验证码并设置新密码</li>
  <li>使用新密码重新登录</li>
</ol>

<h2>四、账号安全建议</h2>
<ul>
  <li>设置包含字母、数字和特殊字符的强密码</li>
  <li>不要将密码告诉他人</li>
  <li>定期更换密码</li>
  <li>不要在公共设备上保存密码</li>
  <li>开启账号异常登录提醒</li>
</ul>`,
    author: '91官方编辑',
    publishDate: '2024-07-15',
    updateDate: '2024-07-20',
    readTime: 7,
    tags: ['91网站使用指南', 'http 91.com'],
  },
  {
    id: 'art-005',
    slug: 'http-91-com-mobile-guide',
    title: 'http 91.com 移动端使用完全手册',
    categorySlug: 'features',
    summary: '全面讲解 http 91.com 在手机和平板等移动设备上的使用方法和技巧，涵盖移动浏览器访问、功能适配等实用内容。',
    content: `<h2>一、移动端访问概述</h2>
<p>http 91.com 为移动端用户提供了优化的浏览体验。无论您使用的是iOS还是Android设备，都可以获得流畅的使用体验。</p>

<h2>二、移动浏览器访问</h2>
<p>使用手机自带浏览器即可访问 http 91.com，无需下载额外应用：</p>
<ul>
  <li>iOS用户：推荐使用Safari浏览器</li>
  <li>Android用户：推荐使用Chrome浏览器</li>
  <li>其他选择：Edge、Firefox等主流浏览器均可</li>
</ul>

<h2>三、移动端特色功能</h2>
<ul>
  <li><strong>自适应布局：</strong>页面自动适配不同屏幕尺寸</li>
  <li><strong>触控优化：</strong>按钮和链接针对手指操作优化</li>
  <li><strong>快速加载：</strong>针对移动网络优化的页面加载速度</li>
  <li><strong>省流量模式：</strong>减少图片和视频的流量消耗</li>
</ul>

<h2>四、添加到桌面</h2>
<p>将 http 91.com 添加到手机桌面，像APP一样快速打开：</p>
<ol>
  <li>在浏览器中打开 http 91.com</li>
  <li>点击浏览器菜单中的"添加到主屏幕"</li>
  <li>确认添加后，桌面会出现网站图标</li>
  <li>点击图标即可快速访问平台</li>
</ol>

<h2>五、移动端使用技巧</h2>
<ul>
  <li>横屏模式可获得更宽广的浏览视野</li>
  <li>使用浏览器的阅读模式提升阅读体验</li>
  <li>开启夜间模式保护眼睛</li>
  <li>定期清理浏览器缓存提升运行速度</li>
</ul>`,
    author: '91官方编辑',
    publishDate: '2024-07-10',
    updateDate: '2024-07-18',
    readTime: 6,
    tags: ['91网站使用指南', 'http 91.com 访问教程', 'http 91.com'],
  },
  {
    id: 'art-006',
    slug: 'http-91-com-access-issues-solutions',
    title: 'http 91.com 访问异常排查与解决方案',
    categorySlug: 'faq',
    summary: '汇总用户在访问 http 91.com 时可能遇到的各种异常情况，并提供详细的排查步骤和解决方案，帮助快速恢复正常访问。',
    content: `<h2>一、常见访问异常类型</h2>
<p>用户在访问 http 91.com 时可能会遇到以下几种常见问题：</p>
<ul>
  <li>页面无法打开或加载超时</li>
  <li>显示"无法连接到服务器"</li>
  <li>页面显示异常或排版错乱</li>
  <li>登录失败或频繁掉线</li>
  <li>页面加载缓慢</li>
</ul>

<h2>二、基础排查步骤</h2>
<p>当您遇到访问问题时，请按照以下步骤逐一排查：</p>
<ol>
  <li><strong>检查网络连接：</strong>确认设备已连接到互联网</li>
  <li><strong>刷新页面：</strong>尝试按F5或点击刷新按钮</li>
  <li><strong>清除缓存：</strong>清除浏览器缓存和Cookie</li>
  <li><strong>更换浏览器：</strong>尝试使用其他浏览器访问</li>
  <li><strong>重启设备：</strong>重启电脑或手机后重新尝试</li>
</ol>

<h2>三、高级解决方案</h2>
<p>如果基础排查无效，可以尝试以下方案：</p>
<ul>
  <li><strong>DNS刷新：</strong>在命令行执行ipconfig /flushdns（Windows）或sudo dscacheutil -flushcache（Mac）</li>
  <li><strong>更换DNS服务器：</strong>尝试使用公共DNS如8.8.8.8或114.114.114.114</li>
  <li><strong>关闭代理/VPN：</strong>暂时关闭代理软件或VPN连接</li>
  <li><strong>检查防火墙设置：</strong>确保防火墙没有阻止浏览器访问</li>
</ul>

<h2>四、联系技术支持</h2>
<p>如果以上方法均无法解决问题，建议：</p>
<ul>
  <li>通过平台官方客服渠道反馈问题</li>
  <li>提供详细的错误信息和截图</li>
  <li>描述问题出现的具体时间和操作步骤</li>
</ul>`,
    author: '91官方编辑',
    publishDate: '2024-07-05',
    updateDate: '2024-07-12',
    readTime: 7,
    tags: ['http 91.com', 'http 91.com 访问教程', '常见问题'],
  },
  {
    id: 'art-007',
    slug: 'http-91-com-privacy-security',
    title: 'http 91.com 隐私保护与账号安全指南',
    categorySlug: 'faq',
    summary: '详述 http 91.com 平台的隐私保护机制和用户账号安全设置，帮助用户全面了解如何保护个人信息安全。',
    content: `<h2>一、平台隐私保护机制</h2>
<p>http 91.com 高度重视用户隐私保护，采取多重安全措施确保用户信息安全：</p>
<ul>
  <li>数据加密传输：所有数据传输均采用加密协议</li>
  <li>访问控制：严格的内部数据访问权限管理</li>
  <li>安全审计：定期进行安全检查和漏洞修复</li>
  <li>合规认证：遵循相关数据保护法律法规</li>
</ul>

<h2>二、个人信息管理</h2>
<p>用户可以自主管理个人信息的可见范围：</p>
<ul>
  <li>设置个人资料的公开范围</li>
  <li>控制谁可以查看您的动态</li>
  <li>管理第三方应用授权</li>
  <li>查看和下载个人数据</li>
</ul>

<h2>三、账号安全加固</h2>
<ol>
  <li>设置高强度密码并定期更换</li>
  <li>绑定手机号和邮箱作为安全验证方式</li>
  <li>开启登录保护功能</li>
  <li>定期检查最近登录记录</li>
  <li>不在公共设备上保存登录状态</li>
</ol>

<h2>四、防范网络诈骗</h2>
<p>请警惕以下常见诈骗手段：</p>
<ul>
  <li>冒充官方客服索要账号密码</li>
  <li>虚假中奖信息诱导点击链接</li>
  <li>仿冒 http 91.com 的钓鱼网站</li>
  <li>要求转账或付费的虚假服务</li>
</ul>`,
    author: '91官方编辑',
    publishDate: '2024-06-28',
    updateDate: '2024-07-05',
    readTime: 6,
    tags: ['http 91.com', '账号安全', '91网站使用指南'],
  },
  {
    id: 'art-008',
    slug: 'http-91-com-updates-2024',
    title: 'http 91.com 2024年度更新日志与版本演进',
    categorySlug: 'updates',
    summary: '记录 http 91.com 平台在2024年的重要更新内容、版本演进历程以及各项功能优化，帮助用户了解平台最新变化。',
    content: `<h2>一、2024年更新概览</h2>
<p>http 91.com 在2024年持续优化迭代，推出了多项重要更新，以下是本年度的主要更新内容：</p>

<h2>二、第一季度更新（1月-3月）</h2>
<ul>
  <li>全新首页设计上线，界面更加简洁现代</li>
  <li>优化搜索引擎，搜索准确度提升30%</li>
  <li>新增夜间模式功能</li>
  <li>移动端体验全面升级</li>
</ul>

<h2>三、第二季度更新（4月-6月）</h2>
<ul>
  <li>社区互动功能增强，新增话题讨论区</li>
  <li>个人中心改版，操作更加便捷</li>
  <li>内容推荐算法升级</li>
  <li>安全防护能力提升</li>
</ul>

<h2>四、第三季度更新（7月-9月）</h2>
<ul>
  <li>新增收藏夹分类管理功能</li>
  <li>通知系统优化，支持消息分类</li>
  <li>性能全面优化，页面加载速度提升</li>
  <li>数据统计功能上线</li>
</ul>

<h2>五、未来展望</h2>
<p>http 91.com 将持续关注用户需求，不断优化平台体验。更多功能正在研发中，敬请期待！</p>`,
    author: '91官方编辑',
    publishDate: '2024-08-01',
    updateDate: '2024-08-06',
    readTime: 5,
    tags: ['http 91.com', '最新动态', '91平台功能介绍'],
  },
  {
    id: 'art-009',
    slug: 'http-91-com-new-user-guide',
    title: 'http 91.com 新用户7天上手指南',
    categorySlug: 'getting-started',
    summary: '专为新用户定制的7天学习计划，每天一个小目标，帮助您快速熟悉 http 91.com 平台的全部核心功能和操作流程。',
    content: `<h2>第一天：注册与基础设置</h2>
<p>访问 http 91.com，完成账号注册，设置个人资料和头像，浏览平台首页了解整体结构。</p>

<h2>第二天：内容浏览与搜索</h2>
<p>学习如何使用分类导航和搜索功能找到感兴趣的内容，了解平台的推荐机制。</p>

<h2>第三天：互动功能入门</h2>
<p>尝试对内容进行点赞、收藏，学习如何发表评论和参与社区讨论。</p>

<h2>第四天：个人中心管理</h2>
<p>熟悉个人中心的各项功能，包括历史记录、收藏管理、账号设置等。</p>

<h2>第五天：高级功能探索</h2>
<p>探索平台的高级功能，如个性化推荐设置、隐私选项配置、通知偏好管理等。</p>

<h2>第六天：移动端使用</h2>
<p>在手机或平板上登录 http 91.com，体验移动端的各项功能，学习移动端特有的操作技巧。</p>

<h2>第七天：安全设置与进阶</h2>
<p>完成账号安全设置，了解平台规则和社区规范，总结一周学习成果，开启深度使用之旅。</p>`,
    author: '91官方编辑',
    publishDate: '2024-06-20',
    updateDate: '2024-07-01',
    readTime: 8,
    tags: ['http 91.com 访问教程', '91网站使用指南', 'http 91.com'],
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getLatestArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
}